import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Field,
  Form,
  getFormValues,
  reduxForm,
} from 'redux-form';

import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import CategoryIcon from '@material-ui/icons/GroupWork';
import DateIcon from '@material-ui/icons/DateRange';
import Paper from '@material-ui/core/Paper';

import DatePicker from '@components/DatePicker/DatePicker';
import Icon from '@components/Icon/Icon';
import Select from '@components/Select/Select';

import './DocketsFilters.scss';

const isButtonDisabled = (formValues, filterValues) => Object
  .entries(formValues)
  .every(([formName, formValue]) => formValue === (filterValues[formName] || ''));

const DocketsFilters = ({
  docketsClaimList,
  docketsTypes,
  handleSubmit,
  formValues,
  filterValues,
}) => (
  <Paper className="dockets-filters">
    <Form onSubmit={handleSubmit}>
      <div className="dockets-filters__title">
        Filters
      </div>
      <div className="dockets-filters__content">
        <div className="dockets-filters__group">
          <Icon className="dockets-filters__icon">
            <DateIcon />
          </Icon>
          <div className="dockets-filters__input-wrapper">
            <Field
              name="dateFrom"
              label="Filed From"
              component={DatePicker}
            />
          </div>
        </div>
        <div className="dockets-filters__group">
          <Icon className="dockets-filters__icon">
            <DateIcon />
          </Icon>
          <div className="dockets-filters__input-wrapper">
            <Field
              name="dateTo"
              label="Filed From"
              component={DatePicker}
            />
          </div>
        </div>
        <div className="dockets-filters__group">
          <Icon className="dockets-filters__icon">
            <CategoryIcon />
          </Icon>
          <div className="dockets-filters__input-wrapper">
            <Field
              name="type"
              label="Type"
              placeholder="Select dockets type"
              options={docketsTypes}
              component={Select}
            />
          </div>
        </div>
        <div className="dockets-filters__group">
          <Icon className="dockets-filters__icon">
            <BookIcon />
          </Icon>
          <div className="dockets-filters__input-wrapper">
            <Field
              name="claimId"
              label="Claim Number"
              placeholder="Select claim number"
              options={docketsClaimList}
              component={Select}
            />
          </div>
        </div>
        <div className="dockets-filters__filter-button">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isButtonDisabled(formValues, filterValues)}
          >
            Filter dockets
          </Button>
        </div>
      </div>
    </Form>
  </Paper>
);

DocketsFilters.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  docketsClaimList: PropTypes.arrayOf(PropTypes.object).isRequired,
  docketsTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  filterValues: PropTypes.object.isRequired,
  formValues: PropTypes.object,
};

DocketsFilters.defaultProps = {
  formValues: {},
};

const mapStateToProps = state => ({
  formValues: getFormValues('dockets-filters')(state),
});

export default reduxForm({
  form: 'dockets-filters',
})(connect(mapStateToProps)(DocketsFilters));



// WEBPACK FOOTER //
// ./src/routes/Case/Dockets/components/DocketsFilters/DocketsFilters.js